import { FC } from 'react';

import Button from 'components/_core/Button';
import { SunshineCardProps } from 'components/_core/SunshineCard';
import SunshineDropdown from 'components/_core/SunshineDropdown';

import CreateCard from '../CreateCard';
import locales from './locales';

interface AddNewButtonProps {
  onAddFromCatalog: () => void;
  onCreateOneOff: () => void;
  isItemsCatalogEnabled: boolean;
}

const AddNewButton: FC<AddNewButtonProps> = ({
  isItemsCatalogEnabled,
  onAddFromCatalog,
  onCreateOneOff,
}) => {
  if (!isItemsCatalogEnabled) {
    return (
      <Button
        alignSelf="flex-start"
        icon="plus"
        iconPosition="left"
        onClick={() => onCreateOneOff()}
      >
        {locales.addItemSimple}
      </Button>
    );
  }

  const cardProps: SunshineCardProps = {
    _hover: { backgroundColor: 'inherit' },
    backgroundColor: 'inherit',
    isBoxed: false,
    paddingX: 'space-0',
    paddingY: 'space-8',
  };

  return (
    <SunshineDropdown placement="bottom-end" strategy="fixed">
      <SunshineDropdown.Trigger>
        <Button icon="chevron-down">{locales.addItemDropdown}</Button>
      </SunshineDropdown.Trigger>

      <SunshineDropdown.List>
        <SunshineDropdown.Item>
          <CreateCard
            {...cardProps}
            description={locales.fromCatalog.description}
            icon="tag"
            onClick={onAddFromCatalog}
            padding="space-0"
            title={locales.fromCatalog.title}
          />
        </SunshineDropdown.Item>

        <SunshineDropdown.Divider />

        <SunshineDropdown.Item>
          <CreateCard
            {...cardProps}
            description={locales.oneOff.description}
            icon="add-file"
            onClick={onCreateOneOff}
            padding="space-0"
            title={locales.oneOff.title}
          />
        </SunshineDropdown.Item>
      </SunshineDropdown.List>
    </SunshineDropdown>
  );
};

export default AddNewButton;
